import './ContactForm.css'
 import React from 'react'
 import {useForm} from "react-hook-form"
 function ContactForm() {
  const {
    register,
    handleSubmit,
    // watch,
    formState: { errors },
  } = useForm()

 const onSubmit = async (data) => {
  console.log("Form data:", data);

  try {
    const response = await fetch("/api/contact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const result = await response.json();

    if (response.ok) {
      alert("Message sent successfully!");
      console.log(result);
    } else {
      alert("Something went wrong!");
    }

  } catch (error) {
    console.error("Error:", error);
    alert("Could not connect to server.");
  }
};
   return (
     <div className='contact-Form'>
       <form onSubmit={handleSubmit(onSubmit)}>
      {/* register your input into the hook by invoking the "register" function */}
      <label> Name</label>
      <input defaultValue="name" {...register("fullName")} />
      <label>Phone Number</label>
      <input defaultValue="contact number" {...register("phone")} />
      <label>Email</label>
      <input defaultValue="email" {...register("email")} />
      <label>Tell us what's in yur mind</label>
      <input defaultValue="what are you looking for" {...register("message")} />
 <div className="form-group">
    <label>BUSINESS TYPE</label>

    <select {...register("businessType")}>
      <option value="">Select</option>
      <option value="E-commerce">E-commerce</option>
      <option value="Startup">Startup</option>
      <option value="Agency">Agency</option>
      <option value="Personal">Personal</option>
    </select>
  </div>
     

      <input type="submit" />
    </form>
     </div>
   )
 }

 export default ContactForm
 